export const CHECKOUT_URL = 'https://health-ready.impultienda.ar/checkout'

export const BOX_IMAGE =
  'https://cdn.magicpatterns.com/uploads/wurm57WyFq3sdKkbfbnQX7/015c8b0a-d669-475d-8ca4-a5e70be08b31.webp'

export const heroBadges: string[] = [
  '7-Day Money-Back Guarantee',
  'Complete 6-in-1 Teaching System',
  'A Full School Year Already Organized',
  'Ready-to-Teach Lessons & Activities',
  'Printable Worksheets & Assessments',
  'Answer Keys Included',
  'Middle & High School Ready',
]

export const organizedItems: string[] = [
  'Lessons',
  'Visual explanations',
  'Worksheets',
  'Real-life scenarios',
  'Classroom activities',
  'Assessments',
  'Answer keys',
  'Projects',
  'Yearly planning',
]

export const systemPills: string[] = [
  '6 Complete Digital Volumes',
  'A Full School Year Organized',
  'Ready-to-Teach Lessons & Worksheets',
  'Real-Life Activities & Projects',
  'Assessments & Answer Keys',
  'Middle & High School Ready',
]

export interface Volume {
  label: string
  title: string
  subtitle: string
  color: string
  highlights: string[]
  footnote: string
}

export const volumes: Volume[] = [
  {
    label: 'Volume 1',
    title: 'Foundations of Health & Wellness',
    subtitle: 'Build the Health Foundations Students Need',
    color: '#1d4ed8',
    highlights: [
      'Health vs. wellness',
      'Dimensions of wellness',
      'Health influences',
      'Health literacy',
      'Decision-making',
      'Healthy habits & goals',
    ],
    footnote: 'Open the lesson and teach.',
  },
  {
    label: 'Volume 2',
    title: 'Nutrition & Healthy Eating',
    subtitle: 'Make Nutrition Practical, Visual and Easier to Teach',
    color: '#15803d',
    highlights: [
      'Balanced nutrition',
      'Food groups & nutrients',
      'Reading Nutrition Facts labels',
      'Hydration',
      'Food choices & influences',
      'Nutrition myths & marketing',
    ],
    footnote: 'Less theory. More real-life application.',
  },
  {
    label: 'Volume 3',
    title: 'Physical Activity, Fitness & Sleep',
    subtitle: 'Help Students Understand the Habits That Support Everyday Wellness',
    color: '#0e7490',
    highlights: [
      'Physical activity',
      'Components of fitness',
      'Movement in everyday life',
      'Benefits of exercise',
      'Sleep & recovery',
      'Building healthier routines',
    ],
    footnote: 'Show it. Practice it. Apply it.',
  },
  {
    label: 'Volume 4',
    title: 'Mental & Emotional Health',
    subtitle: 'Turn Stress, Emotions and Coping Into Skills Students Can Actually Use',
    color: '#a16207',
    highlights: [
      'Understanding emotions',
      'Stress & stressors',
      'Healthy coping strategies',
      'Problem-solving',
      'Resilience',
      'When and how to seek support',
    ],
    footnote: 'Teach practical skills for real life.',
  },
  {
    label: 'Volume 5',
    title: 'Personal Health, Safety & Relationships',
    subtitle: 'Prepare Students for Health Decisions They’ll Actually Face',
    color: '#b91c1c',
    highlights: [
      'Personal health & hygiene',
      'Healthy relationships',
      'Communication',
      'Boundaries',
      'Peer influence',
      'Personal & digital safety',
    ],
    footnote: 'Give students tools they can use beyond the classroom.',
  },
  {
    label: 'Volume 6',
    title: 'Healthy Choices, Projects & Real-Life Application',
    subtitle: 'Bring the Entire Health Curriculum Together',
    color: '#6d28d9',
    highlights: [
      'Decision challenges',
      'Real-life health scenarios',
      'Wellness planning',
      'Health literacy projects',
      'Performance tasks',
      'Unit assessments',
    ],
    footnote: 'From memorizing definitions to making informed decisions.',
  },
]

export const insideItems: string[] = [
  'Visual teaching pages',
  'Printable worksheets',
  'Real-life scenarios',
  'Discussion activities',
  'Exit tickets',
  'Assessments',
  'Answer keys',
  'Projects',
]

export interface Slide {
  title: string
  caption: string
  image: string
}

export const slides: Slide[] = [
  {
    title: 'What Does ‘Healthy’ Look Like? — bell ringer student activity',
    caption: 'Bell ringers & student activities',
    image:
      'https://cdn.magicpatterns.com/uploads/m2VRHVPZsxAi8ww6qAwZyR/Captura-de-pantalla-2026-10-01-a-las-7.37.01_p._m..webp',
  },
  {
    title: 'Where Does It Fit? — dimensions of wellness sorting worksheet',
    caption: 'Printable worksheets',
    image:
      'https://cdn.magicpatterns.com/uploads/aRTLqoBX6Rqnngdtb3m4Wz/Captura-de-pantalla-2026-10-01-a-las-7.38.14_p._m..webp',
  },
  {
    title: 'Same Topic — Different Sources: health literacy source evaluation',
    caption: 'Health literacy activities',
    image:
      'https://cdn.magicpatterns.com/uploads/xzcqc83yqPdcQsSwwaSG1L/Captura-de-pantalla-2026-10-01-a-las-7.39.21_p._m._(1).webp',
  },
  {
    title: 'What Would You Say? — peer pressure communication scenarios',
    caption: 'Real-life scenarios',
    image:
      'https://cdn.magicpatterns.com/uploads/q8AUeXeeqUXNNDiNQ5g2Mi/Captura-de-pantalla-2026-10-01-a-las-7.41.16_p._m..webp',
  },
  {
    title: 'Foundations of Health & Wellness Challenge — Volume 01 assessment',
    caption: 'Unit assessments',
    image:
      'https://cdn.magicpatterns.com/uploads/8tidLMVXCdoxv2jnASU5a6/Captura-de-pantalla-2026-10-01-a-las-7.41.51_p._m..webp',
  },
]

export interface Bonus {
  label: string
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    label: 'Bonus 1',
    title: 'The Full-Year Health Teacher Planner™',
    description:
      'Plan the whole school year, from curriculum pacing and weekly lessons to assessments, student mastery and reteaching.',
  },
  {
    label: 'Bonus 2',
    title: '100 Printable Health Worksheets™',
    description:
      'A full-year library of ready-to-print student activities covering wellness, nutrition, health literacy, fitness, sleep, mental health, relationships and safety.',
  },
  {
    label: 'Bonus 3',
    title: 'Tests, Quizzes & Answer Keys™',
    description:
      'Ready-to-use quick checks, quizzes, unit tests, performance assessments, rubrics and teacher answer keys.',
  },
  {
    label: 'Bonus 4',
    title: 'Classroom Activities & Discussion Cards™',
    description:
      '30 ready-to-use classroom activities plus 80 discussion cards to make Health lessons more interactive without adding more preparation.',
  },
  {
    label: 'Bonus 5',
    title: 'Projects, Rubrics & Performance Assessment Pack™',
    description:
      'Ready-to-assign Health projects, mini-projects, presentation tools, performance tasks, rubrics and a complete final capstone project.',
  },
]

export interface Differentiator {
  title: string
  description: string
}

export const differentiators: Differentiator[] = [
  {
    title: 'Practical',
    description: 'Built around real-life health skills and decisions.',
  },
  {
    title: 'Visual',
    description: 'Charts, cards, diagrams, scenarios and classroom-ready resources.',
  },
  {
    title: 'Organized',
    description: 'Every topic follows a clear progression.',
  },
  {
    title: 'Ready to Use',
    description: 'Print it. Project it. Teach it.',
  },
  {
    title: 'Built for Teachers',
    description: 'Removes the planning workload.',
  },
]

export const offerChecklist: string[] = [
  '6 Complete Volumes',
  '5 Strategic Bonuses',
  'A Full School Year',
  'Worksheets & Activities',
  'Assessments & Answer Keys',
  'Instant Digital Access',
]

export const offerAssurances: string[] = [
  'Instant Download',
  '7-Day Money-Back Guarantee',
  'No Monthly Fees',
  'Access From Computer or Tablet',
  'Print the Materials You Need',
]

export const differenceOneThings: string[] = [
  'one worksheet.',
  'Or one lesson.',
  'Or one unit.',
  'Or a random collection of activities.',
]

export const youKnowItems: string[] = [
  'what to teach',
  'what order to teach it in',
  'what activity to use',
  'what worksheet to print',
  'how students can practice',
  'how to assess understanding',
  'what answers to expect',
  'what comes next',
]

export const finalCtaPoints: string[] = [
  '6 Complete Volumes',
  '5 Strategic Bonuses',
  'A Full School Year',
  'Answer Keys Included',
]

export interface PurchaseNotice {
  name: string
  city: string
  minutesAgo: number
}

export const purchaseNotices: PurchaseNotice[] = [
  { name: 'Jessica M.', city: 'Austin, TX', minutesAgo: 3 },
  { name: 'Michael T.', city: 'Columbus, OH', minutesAgo: 8 },
  { name: 'Sarah L.', city: 'Denver, CO', minutesAgo: 14 },
  { name: 'David B.', city: 'Atlanta, GA', minutesAgo: 21 },
  { name: 'Emily R.', city: 'Phoenix, AZ', minutesAgo: 27 },
  { name: 'Chris P.', city: 'Charlotte, NC', minutesAgo: 35 },
  { name: 'Amanda K.', city: 'Portland, OR', minutesAgo: 42 },
  { name: 'Jason W.', city: 'Nashville, TN', minutesAgo: 51 },
]

export interface Faq {
  question: string
  answer: string[]
  bullets?: string[]
  closing?: string
}

export const faqs: Faq[] = [
  {
    question: 'What is HEALTH READY™?',
    answer: [
      'HEALTH READY™ is a complete digital Health Education teaching system designed to help teachers organize and teach a full school year without creating every lesson from scratch.',
    ],
  },
  {
    question: 'Is this a physical product?',
    answer: [
      'No. HEALTH READY™ is a digital product.',
      'You receive digital materials that you can access from your computer or tablet and print as needed.',
    ],
  },
  {
    question: 'Who is it designed for?',
    answer: [
      'It is designed primarily for Middle School and High School Health Education teachers, as well as educators who teach Health-related classes.',
    ],
  },
  {
    question: 'Is it suitable for new teachers?',
    answer: [
      'Yes.',
      'The system is organized so teachers can follow a clear progression, choose the topic, open the material and teach.',
    ],
  },
  {
    question: 'Does it cover a full school year?',
    answer: [
      'Yes.',
      'HEALTH READY™ is structured as a complete full-year Health Education system across six organized volumes.',
    ],
  },
  {
    question: 'What topics are included?',
    answer: [
      'The system covers Health & Wellness, Nutrition, Physical Activity & Fitness, Sleep, Mental & Emotional Health, Relationships, Communication, Personal Safety, Digital Health, Healthy Decision-Making and real-life application.',
    ],
  },
  {
    question: 'Can I print the materials?',
    answer: [
      'Yes.',
      'Worksheets, activities, assessments, project materials and other classroom resources are designed to be printable.',
    ],
  },
  {
    question: 'Are answer keys included?',
    answer: [
      'Yes.',
      'Answer keys and teacher guidance are included for relevant activities and assessments.',
    ],
  },
  {
    question: 'Are there monthly fees?',
    answer: ['No.', 'HEALTH READY™ is a one-time payment. There is no subscription.'],
  },
  {
    question: 'How quickly do I receive access?',
    answer: ['Access is digital and provided after purchase.'],
  },
  {
    question: 'Can I use the materials on a computer or tablet?',
    answer: [
      'Yes.',
      'You can access the digital resources from compatible computers or tablets and print the materials you need.',
    ],
  },
  {
    question: 'What if it isn’t right for me?',
    answer: [
      'Your purchase includes a 7-day money-back guarantee according to the applicable guarantee terms.',
    ],
  },
]
